import component from './SearchBar';

export default component;
